export default __webpack_public_path__ + "static/media/solomon.c494f0ab.jpg";